import { useMemo } from "react";
import styled from "styled-components";
import {
  ApprovalTemplateEntity,
  Approval_Sort
} from "../../../generated/graphql";

interface IProps {
  selectedTemplate?: ApprovalTemplateEntity;
}

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
`;

const Summary = styled.dl`
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr) 140px minmax(0, 1fr);
  margin: 0;
`;

const Description = styled.dl`
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr);
  flex: 1;
  min-width: 0;
  min-height: 0;
  margin: 0;
  overflow: hidden;
`;

const Label = styled.dt`
  display: flex;
  width: 140px;
  min-width: 140px;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: ${props => props.theme.colors.lightGrey};
  border-bottom: 1px solid ${props => props.theme.colors.littleLightGrey};
  font-weight: bold;
  text-align: center;
`;

const Value = styled.dd`
  display: flex;
  min-width: 0;
  min-height: 40px;
  box-sizing: border-box;
  align-items: center;
  margin: 0;
  padding: 10px;
  background-color: ${props => props.theme.colors.white};
  border-bottom: 1px solid ${props => props.theme.colors.littleLightGrey};
  overflow-wrap: anywhere;
`;

const DescriptionValue = styled(Value)`
  min-height: 0;
  align-items: flex-start;
  overflow: auto;
  white-space: pre-wrap;
`;

function ApprovalFormDetailInfo({ selectedTemplate }: IProps) {
  const approvalType = useMemo(() => {
    if (selectedTemplate?.approvalType) {
      return selectedTemplate.approvalType === Approval_Sort.ApprovalLine
        ? "결재선"
        : "자동결재";
    }
    return "";
  }, [selectedTemplate]);
  return (
    <Container>
      <Summary>
        <Label data-testid="approval-form-detail-label">이름</Label>
        <Value>{selectedTemplate?.templateTitle}</Value>
        <Label data-testid="approval-form-detail-label">정보구분</Label>
        <Value>{selectedTemplate?.name}</Value>
        <Label data-testid="approval-form-detail-label">결재방식</Label>
        <Value>{approvalType}</Value>
        <Label data-testid="approval-form-detail-label">결재 양식</Label>
        <Value>{selectedTemplate?.formName}</Value>
      </Summary>
      <Description>
        <Label data-testid="approval-form-detail-label">설명</Label>
        <DescriptionValue>
          {selectedTemplate?.description ?? ""}
        </DescriptionValue>
      </Description>
    </Container>
  );
}

export default ApprovalFormDetailInfo;
